import { useEffect, useState } from 'react';
import { FLIGHTS_ROUTES } from '@/constants/common.constants';

function useFareCalendarBaseQuery(query, router) {
  const [baseQuery, setBaseQuery] = useState(query);
  const [shouldUpdate, setShouldUpdate] = useState(false);

  const handleUpdate = (url, { shallow }) => {
    if (!url.includes(FLIGHTS_ROUTES.RESULTS.split('{')[0]) && shallow) {
      setShouldUpdate(true);
    }
  };

  useEffect(() => {
    router.events.on('routeChangeStart', handleUpdate);

    return () => {
      router.events.off('routeChangeStart', handleUpdate);
    };
  }, []);

  useEffect(() => {
    if (shouldUpdate && query !== baseQuery) {
      setBaseQuery(query);
      setShouldUpdate(false);
    }
  }, [baseQuery, query, shouldUpdate]);

  return baseQuery;
}

export default useFareCalendarBaseQuery;
